import { AfterViewInit, Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { DomSanitizer, SafeResourceUrl, SafeStyle } from '@angular/platform-browser';
import { MediaItem } from '../../app.models';
import { CarouselComponent } from 'ngx-bootstrap/carousel';
import { Router } from '@angular/router';
// import { YouTubeService } from '../../services/youtube.service';
// import YouTubePlayer from 'yt-player';

declare var $: any;

@Component({
  selector: 'app-section-image-content',
  templateUrl: './section-image-content.component.html',
  styleUrls: ['./section-image-content.component.scss']
})
export class SectionImageContentComponent implements OnInit, OnChanges, AfterViewInit {
  @ViewChild('carousel', { static: false }) carousel: CarouselComponent;

  @Input() contentLeft = true;
  @Input() contentLink: string;
  @Input() fixedAspectRatio = true;
  @Input() imageUrl: string;
  @Input() videoUrl: string;
  @Input() embedUrl: string;
  @Input() embedLabel: string;
  @Input() mediaItems: MediaItem[];

  @Input() mobileImageBackground = true;
  @Input() classes = '';
  @Input() center = true;

  imageSafeStyleUrl: SafeStyle;
  imageSafeResourceUrl: SafeResourceUrl;
  videoSafeResourceUrl: SafeResourceUrl;
  embedSafeResourceUrl: SafeResourceUrl;
  safeStyleUrlCache = {};
  safeResourceUrlCache = {};
  // player: YouTubePlayer;
  autoplayVideo = false;

  constructor(private sanitize: DomSanitizer, private router: Router) {}

  async ngOnInit() {
    this.updateSafeUrls();
  }

  async ngAfterViewInit() {
    // await this.youtubeService.loadAPI();
    //
    // setTimeout(() => {
    //   // this.player = this.youtubeService.createPlayer('player');
    //   const el = $('#player');
    //   // console.log('player el is now', this.playerEl);
    //
    //   this.player = new YouTubePlayer(el);
    // //console.log('player is now', this.player);
    //   this.player.load('Z0Le24TuWrA');
    //   this.player.on('error', (err) => {
    //     console.error('error loading video', err);
    //   });
    //   this.player.on('unplayable', (err) => {
    //     console.error('unplayable', err);
    //   });
    //   this.player.on('playing', () => {
    //   //console.log(this.player.getDuration()); // => 351.521
    //   });
    // }, 5000);
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.updateSafeUrls();
  }

  async gotoRoute(route, event?: Event) {
  //console.log('route clicked', route);
    if (!!route && !!event) {
      event.preventDefault();
      event.stopPropagation();
    }

    if (!!route) {
    //console.log('navigating to route', route);
      if (this.isRemoteUrl(route)) {
        window.open(route, '_blank');
      } else {
        await this.router.navigateByUrl(route);
      }
    }
    return true;
  }

  isRemoteUrl(url: string) {
    return url != null && (!!url.match(/^https?:/) || !!url.match(/^\/\//));
  }

  updateSafeUrls() {
    if (!!this.imageUrl) {
      this.imageSafeStyleUrl = this.safeStyle(this.imageUrl);
      this.imageSafeResourceUrl = this.safeResourceUrl(this.imageUrl);
    }
    if (!!this.videoUrl) {
      this.videoSafeResourceUrl = this.safeResourceUrl(this.videoUrl);
    }
    if (!!this.embedUrl) {
      let extra = this.embedUrl.indexOf('?') === 0 ? 'enablejsapi=1' : '&enablejsapi=1';
      extra += `&origin=${location.host}`;
      const url = this.embedUrl + extra;
      // console.log('loading embed URL', url);
      this.embedSafeResourceUrl = this.safeResourceUrl(url);
    }

    // update all media urls
    if (!!this.mediaItems) {
      for (const media of this.mediaItems) {
        if (!!media.embedUrl) {
          this.safeResourceUrlCache[media.embedUrl] = {};
          this.safeResourceUrlCache[media.embedUrl][true] = this.safeResourceUrl(media.embedUrl, true, true);
          this.safeResourceUrlCache[media.embedUrl][false] = this.safeResourceUrl(media.embedUrl, false, true);
          // console.log('embedUrl w/autoplay', this.safeResourceUrlCache[media.embedUrl][true]);
          // console.log('embedUrl wo/autoplay', this.safeResourceUrlCache[media.embedUrl][false]);
        }
        if (!!media.imageUrl) {
          this.safeResourceUrlCache[media.imageUrl] = this.safeResourceUrl(media.imageUrl);
        }
        if (!!media.videoUrl) {
          this.safeResourceUrlCache[media.videoUrl] = this.safeResourceUrl(media.videoUrl);
        }
      }
    }
  }

  safeStyle(url: string): SafeStyle {
    if (!!this.safeStyleUrlCache[url]) {
      // console.log('safeStyle(): cached');
      return this.safeStyleUrlCache[url];
    }
    // console.log('safeStyle()');
    this.safeStyleUrlCache[url] = this.sanitize.bypassSecurityTrustStyle('url(' + url + ')');
    return this.safeStyleUrlCache[url];
  }

  safeResourceUrl(url: string, autoplayVideo?: boolean, embed?: boolean): SafeResourceUrl {
    if (!url) {
      return;
    }

    let fullUrl = url;
    let haveParams = fullUrl.indexOf('?') >= 0;
    if (autoplayVideo === true) {
      if (!haveParams) {
        fullUrl += '?autoplay=1';
      } else {
        fullUrl += '&autoplay=1';
      }
      haveParams = true;
    }

    // if (!!this.safeResourceUrlCache[fullUrl]) {
    //   // console.log('safeResourceUrl(): cached');
    //   // console.log('returning cached URL', url);
    //   return this.safeResourceUrlCache[fullUrl];
    // }

    // console.log('safeResourceUrl()');

    if (embed === true) {
      let extra = !haveParams ? '?enablejsapi=1' : '&enablejsapi=1';
      extra += `&origin=${location.href}`;
      fullUrl = (!!fullUrl.startsWith('http') ? '' : location.protocol) + fullUrl + extra;
    }

    // console.log('loading URL', fullUrl);

    // this.safeResourceUrlCache[url] = this.sanitize.bypassSecurityTrustResourceUrl(fullUrl);
    // return this.safeResourceUrlCache[url];
    return this.sanitize.bypassSecurityTrustResourceUrl(fullUrl);
  }

  playerLoaded(event) {
  //console.log('player loaded');
  }

  playVideo() {
    this.carousel.selectSlide(this.carousel.slides.length - 1);
    this.autoplayVideo = true;
    this.updateSafeUrls();
    // if (!!this.player) {
    // //console.log('playing video', this.player.getDuration());
    //   this.player.play();
    // } else {
    // //console.log('no player, NOT playing video');
    // }
    // $('#embed')[0].src += '&autoplay=1';
  }
}
